import http from "./httpService";
import config from "./../config.json";

let apiEndpoint = process.env.REACT_APP_API_URL || config.apiUrl;
apiEndpoint += "referrals";

export const generateReferralCode = async (id) => {
  const { data } = await http.post(`${apiEndpoint}/accounts/${id}`);
  return data.result;
};

export const assignReferralAsync = async (id, referralId) => {
  const { data } = await http.post(
    `${apiEndpoint}/accounts/${id}/${referralId}`
  );

  return data;
};

export const validateReferralsAsync = async () => {
  return await http.post(`${apiEndpoint}/validate`);
};

export const getAvailableReferralsAsync = async (id, params) => {
  const {
    sort_column,
    search_query: query,
    current_page: page,
    page_size: size,
  } = params;

  const { path: column, order } = sort_column;
  const url = `${apiEndpoint}/accounts/available/${id}?q=${query}&column=${column}&order=${order}&p=${page}&s=${size}`;

  const { data } = await http.get(url);
  return data;
};

export const getReferralsASync = async (params) => {
  const {
    sort_column,
    search_query: query,
    current_page: page,
    page_size: size,
  } = params;

  const { path: column, order } = sort_column;
  const url = `${apiEndpoint}?q=${query}&column=${column}&order=${order}&p=${page}&s=${size}`;

  const { data } = await http.get(url);
  return data;
};

export const getAccountReferralsAsync = async (id) => {
  const { data } = await http.get(`${apiEndpoint}/accounts/${id}`);
  return data;
};

export const referralService = {
  generateReferralCode,
  assignReferralAsync,
  validateReferralsAsync,
  getReferralsASync,
  getAccountReferralsAsync,
  getAvailableReferralsAsync,
};

export default referralService;
